import React from 'react';
import PropTypes from 'prop-types';
import EventAppointmentCard from '../EventAppointmentCard';
import EventSessionListItem from '../EventSessionListItem';

const EventAgendaCard = ({ agendaItem }) => (
    <>
        {agendaItem.type.toUpperCase() === 'APPOINTMENT' && <EventAppointmentCard appointment={agendaItem} />}
        {agendaItem.type.toUpperCase() === 'SESSION' && <EventSessionListItem {...agendaItem} />}
    </>
);

EventAgendaCard.propTypes = {
    agendaItem: PropTypes.object.isRequired,
};

export default EventAgendaCard;
